/* eslint-disable import/prefer-default-export */

export const SET_RUNTIME_VARIABLE = 'SET_RUNTIME_VARIABLE';

export const SET_LOCALE_START = 'SET_LOCALE_START';
export const SET_LOCALE_SUCCESS = 'SET_LOCALE_SUCCESS';
export const SET_LOCALE_ERROR = 'SET_LOCALE_ERROR';

// Get Currency List from Currencies Table
export const GET_CURRENCIES_START = 'GET_CURRENCIES_START';
export const GET_CURRENCIES_SUCCESS = 'GET_CURRENCIES_SUCCESS';
export const GET_CURRENCIES_ERROR = 'GET_CURRENCIES_ERROR';

// Currency Rates Fetch
export const CURRENCY_RATES_FETCH_START = 'CURRENCY_RATES_FETCH_START';
export const CURRENCY_RATES_FETCH_SUCCESS = 'CURRENCY_RATES_FETCH_SUCCESS';
export const CURRENCY_RATES_FETCH_ERROR = 'CURRENCY_RATES_FETCH_ERROR';

// Select Currency from Dropdown
export const CHOSE_TO_CURRENCY_START = 'CHOSE_TO_CURRENCY_START';
export const CHOSE_TO_CURRENCY_SUCCESS = 'CHOSE_TO_CURRENCY_SUCCESS';
export const CHOSE_TO_CURRENCY_ERROR = 'CHOSE_TO_CURRENCY_ERROR';

// Logout
export const ADMIN_USER_LOGOUT_START = "ADMIN_USER_LOGOUT_START";
export const ADMIN_USER_LOGOUT_SUCCESS = "ADMIN_USER_LOGOUT_SUCCESS";
export const ADMIN_USER_LOGOUT_ERROR = "ADMIN_USER_LOGOUT_ERROR";

//Category Image Delete
export const CATEGORY_IMAGE_UPLOAD_START = "CATEGORY_IMAGE_UPLOAD_START";
export const CATEGORY_IMAGE_UPLOAD_SUCCESS = "CATEGORY_IMAGE_UPLOAD_SUCCESS";
export const CATEGORY_IMAGE_UPLOAD_ERROR = "CATEGORY_IMAGE_UPLOAD_ERROR";

//Category Marker Delete
export const CATEGORY_MARKER_UPLOAD_START = "CATEGORY_MARKER_UPLOAD_START";
export const CATEGORY_MARKER_UPLOAD_SUCCESS = "CATEGORY_MARKER_UPLOAD_SUCCESS";
export const CATEGORY_MARKER_UPLOAD_ERROR = "CATEGORY_MARKER_UPLOAD_ERROR";

//User Delete
export const USER_DELETE_START = 'USER_DELETE_START';
export const USER_DELETE_SUCCESS = 'USER_DELETE_SUCCESS';
export const USER_DELETE_ERROR = 'USER_DELETE_ERROR';

//Cancel Reason Delete
export const CANCEL_REASON_DELETE_START = 'CANCEL_REASON_DELETE_START';
export const CANCEL_REASON_DELETE_SUCCESS = 'CANCEL_REASON_DELETE_SUCCESS';
export const CANCEL_REASON_DELETE_ERROR = 'CANCEL_REASON_DELETE_ERROR';

//Driver/Rider profile image upload
export const PROFILE_IMAGE_UPLOAD_START = 'PROFILE_IMAGE_UPLOAD_START';
export const PROFILE_IMAGE_UPLOAD_SUCCESS = 'PROFILE_IMAGE_UPLOAD_SUCCESS';
export const PROFILE_IMAGE_UPLOAD_ERROR = 'PROFILE_IMAGE_UPLOAD_ERROR';

//Driver Licence upload
export const LICENCE_IMAGE_UPLOAD_START = 'LICENCE_IMAGE_UPLOAD_START';
export const LICENCE_IMAGE_UPLOAD_SUCCESS = 'LICENCE_IMAGE_UPLOAD_SUCCESS';
export const LICENCE_IMAGE_UPLOAD_ERROR = 'LICENCE_IMAGE_UPLOAD_ERROR';

//Driver RCbook upload
export const RCBOOK_IMAGE_UPLOAD_START = 'RCBOOK_IMAGE_UPLOAD_START';
export const RCBOOK_IMAGE_UPLOAD_SUCCESS = 'RCBOOK_IMAGE_UPLOAD_SUCCESS';
export const RCBOOK_IMAGE_UPLOAD_ERROR = 'RCBOOK_IMAGE_UPLOAD_ERROR';

//Driver Insurance upload
export const INSURANCE_IMAGE_UPLOAD_START = 'INSURANCE_IMAGE_UPLOAD_START';
export const INSURANCE_IMAGE_UPLOAD_SUCCESS = 'INSURANCE_IMAGE_UPLOAD_SUCCESS';
export const INSURANCE_IMAGE_UPLOAD_ERROR = 'INSURANCE_IMAGE_UPLOAD_ERROR';

// ADD/UPDATE Promo Code 
export const ADD_PROMOCODE_START = 'ADD_PROMOCODE_START';
export const ADD_PROMOCODE_SUCCESS = 'ADD_PROMOCODE_SUCCESS';
export const ADD_PROMOCODE_ERROR = 'ADD_PROMOCODE_ERROR';

// Delete Promo Code 
export const DELETE_PROMOCODE_START = 'DELETE_PROMOCODE_START';
export const DELETE_PROMOCODE_SUCCESS = 'DELETE_PROMOCODE_SUCCESS';
export const DELETE_PROMOCODE_ERROR = 'DELETE_PROMOCODE_ERROR';

// Enable / Disable Currencies
export const CHANGE_CURRENCY_STATUS_START = 'CHANGE_CURRENCY_STATUS_START';
export const CHANGE_CURRENCY_STATUS_SUCCESS = 'CHANGE_CURRENCY_STATUS_SUCCESS';
export const CHANGE_CURRENCY_STATUS_ERROR = 'CHANGE_CURRENCY_STATUS_ERROR';

// Set Base Currency
export const SET_BASE_CURRENCY_START = 'SET_BASE_CURRENCY_START';
export const SET_BASE_CURRENCY_SUCCESS = 'SET_BASE_CURRENCY_SUCCESS';
export const SET_BASE_CURRENCY_ERROR = 'SET_BASE_CURRENCY_ERROR';
//Site Settings upload
export const SITE_SETTINGS_UPLOAD_START = 'SITE_SETTINGS_UPLOAD_START';
export const SITE_SETTINGS_UPLOAD_SUCCESS = 'SITE_SETTINGS_UPLOAD_SUCCESS';
export const SITE_SETTINGS_UPLOAD_ERROR = 'SITE_SETTINGS_UPLOAD_ERROR';

//Homepage Settings upload
export const HOMEPAGE_SETTINGS_UPLOAD_START = 'HOMEPAGE_SETTINGS_UPLOAD_START';
export const HOMEPAGE_SETTINGS_UPLOAD_SUCCESS = 'HOMEPAGE_SETTINGS_UPLOAD_SUCCESS';
export const HOMEPAGE_SETTINGS_UPLOAD_ERROR = 'HOMEPAGE_SETTINGS_UPLOAD_ERROR';

//Site Settings
export const SITE_SETTINGS_START = 'SITE_SETTINGS_START';
export const SITE_SETTINGS_SUCCESS = 'SITE_SETTINGS_SUCCESS';
export const SITE_SETTINGS_ERROR = 'SITE_SETTINGS_ERROR';

// Loader Buttons
export const SET_LOADER_START = 'SET_LOADER_START';
export const SET_LOADER_COMPLETE = 'SET_LOADER_COMPLETE';

// ADD/UPDATE Promo Code 
export const ADD_CANCEL_REASON_START = 'ADD_CANCEL_REASON_START';
export const ADD_CANCEL_REASON_SUCCESS = 'ADD_CANCEL_REASON_SUCCESS';
export const ADD_CANCEL_REASON_ERROR = 'ADD_CANCEL_REASON_ERROR';

// Delete location
export const DELETE_LOCATION_START = 'DELETE_LOCATION_START';
export const DELETE_LOCATION_SUCCESS = 'DELETE_LOCATION_SUCCESS';
export const DELETE_LOCATION_ERROR = 'DELETE_LOCATION_ERROR';

//UPDATE Payout status 
export const SET_PAYOUT_START = 'SET_PAYOUT_START';
export const SET_PAYOUT_SUCCESS = 'SET_PAYOUT_SUCCESS';
export const SET_PAYOUT_ERROR = 'SET_PAYOUT_ERROR';

//UPDATE Cash Payout status 
export const SET_CASH_PAYOUT_START = 'SET_CASH_PAYOUT_START';
export const SET_CASH_PAYOUT_SUCCESS = 'SET_CASH_PAYOUT_SUCCESS';
export const SET_CASH_PAYOUT_ERROR = 'SET_CASH_PAYOUT_ERROR';

// Update Static Page Details
export const ADMIN_UPDATE_STATIC_START = 'ADMIN_UPDATE_STATIC_START';
export const ADMIN_UPDATE_STATIC_SUCCESS = 'ADMIN_UPDATE_STATIC_SUCCESS';
export const ADMIN_UPDATE_STATIC_ERROR = 'ADMIN_UPDATE_STATIC_ERROR';

//Category Delete
export const CATEGORY_DELETE_START = 'CATEGORY_DELETE_START';
export const CATEGORY_DELETE_SUCCESS = 'CATEGORY_DELETE_SUCCESS';
export const CATEGORY_DELETE_ERROR = 'CATEGORY_DELETE_ERROR';

//Category Update
export const CATEGORY_UPDATE_START = 'CATEGORY_UPDATE_START';
export const CATEGORY_UPDATE_SUCCESS = 'CATEGORY_UPDATE_SUCCESS';
export const CATEGORY_UPDATE_ERROR = 'CATEGORY_UPDATE_ERROR';

// Active Inactive Fare
export const UPDATE_PRICING_STATUS_START = 'UPDATE_PRICING_STATUS_START';
export const UPDATE_PRICING_STATUS_SUCCESS = 'UPDATE_PRICING_STATUS_SUCCESS';
export const UPDATE_PRICING_STATUS_ERROR = 'UPDATE_PRICING_STATUS_ERROR';

// Delete Fare
export const DELETE_PRICING_START = 'DELETE_PRICING_START';
export const DELETE_PRICING_SUCCESS = 'DELETE_PRICING_SUCCESS';
export const DELETE_PRICING_ERROR = 'DELETE_PRICING_ERROR';

// ADD UPDATE Fare
export const ADD_UPDATE_PRICING_START = 'ADD_UPDATE_PRICING_START';
export const ADD_UPDATE_PRICING_SUCCESS = 'ADD_UPDATE_PRICING_SUCCESS';
export const ADD_UPDATE_PRICING_ERROR = 'ADD_UPDATE_PRICING_ERROR';

// ADMIN ROLES MODAL
export const OPEN_ADMIN_ROLES_MODAL = 'OPEN_ADMIN_ROLES_MODAL';
export const CLOSE_ADMIN_ROLES_MODAL = 'CLOSE_ADMIN_ROLES_MODAL';

// Create Admin Role
export const CREATE_ADMIN_ROLES_START = 'CREATE_ADMIN_ROLES_START';
export const CREATE_ADMIN_ROLES_SUCCESS = 'CREATE_ADMIN_ROLES_SUCCESS';
export const CREATE_ADMIN_ROLES_ERROR = 'CREATE_ADMIN_ROLES_ERROR';

// Delete Admin Role
export const DELETE_ADMIN_ROLES_START = 'DELETE_ADMIN_ROLES_START';
export const DELETE_ADMIN_ROLES_SUCCESS = 'DELETE_ADMIN_ROLES_SUCCESS';
export const DELETE_ADMIN_ROLES_ERROR = 'DELETE_ADMIN_ROLES_ERROR';

// Create Admin User
export const CREATE_ADMIN_USER_START = 'CREATE_ADMIN_USER_START';
export const CREATE_ADMIN_USER_SUCCESS = 'CREATE_ADMIN_USER_SUCCESS';
export const CREATE_ADMIN_USER_ERROR = 'CREATE_ADMIN_USER_ERROR';

// Delete Admin User
export const DELETE_ADMIN_USER_START = 'DELETE_ADMIN_USER_START';
export const DELETE_ADMIN_USER_SUCCESS = 'DELETE_ADMIN_USER_SUCCESS';
export const DELETE_ADMIN_USER_ERROR = 'DELETE_ADMIN_USER_ERROR';

// ADMIN ROLES MODAL
export const OPEN_ADMIN_USER_MODAL = 'OPEN_ADMIN_USER_MODAL';
export const CLOSE_ADMIN_USER_MODAL = 'CLOSE_ADMIN_USER_MODAL';

// Get Admin User
export const GET_ADMIN_USER_START = 'GET_ADMIN_USER_START';
export const GET_ADMIN_USER_SUCCESS = 'GET_ADMIN_USER_SUCCESS';
export const GET_ADMIN_USER_ERROR = 'GET_ADMIN_USER_ERROR';

// HEADER MODAL
export const OPEN_HEADER_MODAL = 'OPEN_HEADER_MODAL';
export const CLOSE_HEADER_MODAL = 'CLOSE_HEADER_MODAL';

// GET_MAP_DATA 
export const GET_MAP_DATA_START = 'GET_MAP_DATA_START';
export const GET_MAP_DATA_SUCCESS = 'GET_MAP_DATA_SUCCESS';
export const GET_MAP_DATA_ERROR = 'GET_MAP_DATA_ERROR';

export const EDIT_BOOKING_MODAL = 'EDIT_BOOKING_MODAL';
export const CANCEL_BOOKING_MODAL = 'CANCEL_BOOKING_MODAL';

//Mobile Settings upload
export const MOBILE_SETTINGS_UPLOAD_START = 'MOBILE_SETTINGS_UPLOAD_START';
export const MOBILE_SETTINGS_UPLOAD_SUCCESS = 'MOBILE_SETTINGS_UPLOAD_SUCCESS';
export const MOBILE_SETTINGS_UPLOAD_ERROR = 'MOBILE_SETTINGS_UPLOAD_ERROR';

//Currency MODAL
export const OPEN_CURRENCY_MODAL = 'OPEN_CURRENCY_MODAL';

// Add Currency
export const ADD_CURRENCY_START = 'ADD_CURRENCY_START';
export const ADD_CURRENCY_SUCCESS = 'ADD_CURRENCY_SUCCESS';
export const ADD_CURRENCY_ERROR = 'ADD_CURRENCY_ERROR';

//Identity upload
export const IDENTITY_IMAGE_UPLOAD_START = 'IDENTITY_IMAGE_UPLOAD_START';
export const IDENTITY_IMAGE_UPLOAD_SUCCESS = 'IDENTITY_IMAGE_UPLOAD_SUCCESS';
export const IDENTITY_IMAGE_UPLOAD_ERROR = 'IDENTITY_IMAGE_UPLOAD_ERROR';

// Get Admin privileges
export const ADMIN_PRIVILEGES_START = 'ADMIN_PRIVILEGES_START';
export const ADMIN_PRIVILEGES_SUCCESS = 'ADMIN_PRIVILEGES_SUCCESS';
export const ADMIN_PRIVILEGES_ERROR = 'ADMIN_PRIVILEGES_ERROR';

//Admin load Common setting
export const ADMIN_LOAD_COMMON_SETTINGS_START = 'ADMIN_LOAD_COMMON_SETTINGS_START';
export const ADMIN_LOAD_COMMON_SETTINGS_SUCCESS = 'ADMIN_LOAD_COMMON_SETTINGS_SUCCESS';
export const ADMIN_LOAD_COMMON_SETTINGS_ERROR = 'ADMIN_LOAD_COMMON_SETTINGS_ERROR';

//Experience upload
export const EXPERIENCE_IMAGE_UPLOAD_START = 'EXPERIENCE_IMAGE_UPLOAD_START';
export const EXPERIENCE_IMAGE_UPLOAD_SUCCESS = 'EXPERIENCE_IMAGE_UPLOAD_SUCCESS';
export const EXPERIENCE_IMAGE_UPLOAD_ERROR = 'EXPERIENCE_IMAGE_UPLOAD_ERROR';

// Image Slider Lightbox
export const IMAGE_LIGHTBOX_OPEN = 'IMAGE_LIGHTBOX_OPEN';
export const IMAGE_LIGHTBOX_CLOSE = 'IMAGE_LIGHTBOX_CLOSE';

// UPDATE SMS Method 
export const UPDATE_SMS_START = 'UPDATE_SMS_START';
export const UPDATE_SMS_SUCCESS = 'UPDATE_SMS_SUCCESS';
export const UPDATE_SMS_ERROR = 'UPDATE_SMS_ERROR';

//DarkMode Theme
export const CHOSE_TO_THEME_START = 'CHOSE_TO_THEME_START';
export const CHOSE_TO_THEME_SUCCESS = 'CHOSE_TO_THEME_SUCCESS';
export const CHOSE_TO_THEME_ERROR = 'CHOSE_TO_THEME_ERROR';

//Update Config Settings

export const UPDATE_CONFIG_SETTINGS_START = 'UPDATE_CONFIG_SETTINGS_START';
export const UPDATE_CONFIG_SETTINGS_SUCCESS = 'UPDATE_CONFIG_SETTINGS_SUCCESS';
export const UPDATE_CONFIG_SETTINGS_ERROR = 'UPDATE_CONFIG_SETTINGS_ERROR';

export const UPDATE_PAYMENT_STATUS_START = 'UPDATE_PAYMENT_STATUS_START';
export const UPDATE_PAYMENT_STATUS_SUCCESS = 'UPDATE_PAYMENT_STATUS_SUCCESS';
export const UPDATE_PAYMENT_STATUS_ERROR = 'UPDATE_PAYMENT_STATUS_ERROR';

//TopFeature Delete
export const TOPFEATURE_DELETE_START = 'TOPFEATURE_DELETE_START';
export const TOPFEATURE_DELETE_SUCCESS = 'TOPFEATURE_DELETE_SUCCESS';
export const TOPFEATURE_DELETE_ERROR = 'TOPFEATURE_DELETE_ERROR';

// TopFeature status
export const TOPFEATURE_UPDATE_START = 'TOPFEATURE_UPDATE_START';
export const TOPFEATURE_UPDATE_SUCCESS = 'TOPFEATURE_UPDATE_SUCCESS';
export const TOPFEATURE_UPDATE_ERROR = 'TOPFEATURE_UPDATE_ERROR';

// ManualBooking 
export const OPEN_DESCRIPTION_MODAL = 'OPEN_DESCRIPTION_MODAL';
export const CLOSE_DESCRIPTION_MODAL = 'CLOSE_DESCRIPTION_MODAL';

// ManualBooking 
export const CREATE_MANUAL_BOOKING_START = 'CREATE_MANUAL_BOOKING_START';
export const CREATE_MANUAL_BOOKING_SUCCESS = 'CREATE_MANUAL_BOOKING_SUCCESS';
export const CREATE_MANUAL_BOOKING_ERROR = 'CREATE_MANUAL_BOOKING_ERROR';

export const CANCEL_SCHEDULED_BOOKING_MODAL = 'CANCEL_SCHEDULED_BOOKING_MODAL';

export const OPEN_SCHEDULED_BOOKING_MODAL = 'OPEN_SCHEDULED_BOOKING_MODAL';
export const CLOSE_SCHEDULED_BOOKING_MODAL = 'CLOSE_SCHEDULED_BOOKING_MODAL';

export const UPDATE_SCHEDULE_BOOKING_START = 'UPDATE_SCHEDULE_BOOKING_START';
export const UPDATE_SCHEDULE_BOOKING_SUCCESS = 'UPDATE_SCHEDULE_BOOKING_SUCCESS';
export const UPDATE_SCHEDULE_BOOKING_ERROR = 'UPDATE_SCHEDULE_BOOKING_ERROR';

export const GET_PREFERRED_PROVIDER_START = 'GET_PREFERRED_PROVIDER_START';
export const GET_PREFERRED_PROVIDER_SUCCESS = 'GET_PREFERRED_PROVIDER_SUCCESS';
export const GET_PREFERRED_PROVIDER_ERROR = 'GET_PREFERRED_PROVIDER_ERROR';

//Loader color code
export const LIGHTMODE_LOADER_COMMON_COLOR = '#000000';
export const DARKMODE_LOADER_COMMON_COLOR = '#ffffff';

//Login Modal
export const OPEN_LOGIN_MODAL = 'OPEN_LOGIN_MODAL';
export const CLOSE_LOGIN_MODAL = 'CLOSE_LOGIN_MODAL';

//Login OTP Modal
export const OPEN_OTP_MODAL = 'OPEN_OTP_MODAL';
export const CLOSE_OTP_MODAL = 'CLOSE_OTP_MODAL';


// SEND VERIFICATION SMS
export const SEND_VERIFICATION_SMS_START = 'SEND_VERIFICATION_SMS_START';
export const SEND_VERIFICATION_SMS_SUCCESS = 'SEND_VERIFICATION_SMS_SUCCESS';
export const SEND_VERIFICATION_SMS_ERROR = 'SEND_VERIFICATION_SMS_ERROR';

export const VERIFY_OTP_START = 'VERIFY_OTP_START';
export const VERIFY_OTP_SUCCESS = 'VERIFY_OTP_SUCCESS';
export const VERIFY_OTP_ERROR = 'VERIFY_OTP_ERROR';
// Load User Account Data
export const SET_USER_DATA_START = 'SET_USER_DATA_START';
export const SET_USER_DATA_SUCCESS = 'SET_USER_DATA_SUCCESS';
export const SET_USER_DATA_ERROR = 'SET_USER_DATA_ERROR';

// User Logout
export const USER_LOGOUT_START = "USER_LOGOUT_START";
export const USER_LOGOUT_SUCCESS = "USER_LOGOUT_SUCCESS";
export const USER_LOGOUT_ERROR = "USER_LOGOUT_ERROR";

// Category data
export const GET_CATEGORY_DATA_START = 'GET_CATEGORY_DATA_START';
export const GET_CATEGORY_DATA_SUCCESS = 'GET_CATEGORY_DATA_SUCCESS';
export const GET_CATEGORY_DATA_ERROR = 'GET_CATEGORY_DATA_ERROR';


export const FETCH_SEARCH_RESULTS_START = 'FETCH_SEARCH_RESULTS_START';
export const FETCH_SEARCH_RESULTS_SUCCESS = 'FETCH_SEARCH_RESULTS_SUCCESS';
export const FETCH_SEARCH_RESULTS_ERROR = 'FETCH_SEARCH_RESULTS_ERROR';


// Search category
export const SEARCH_CATEGORY_START = 'SEARCH_CATEGORY_START';
export const SEARCH_CATEGORY_SUCCESS = 'SEARCH_CATEGORY_SUCCESS';
export const SEARCH_CATEGORY_ERROR = 'SEARCH_CATEGORY_ERROR';


export const ADD_ORDER_START = 'ADD_ORDER_START';
export const ADD_ORDER_SUCCESS = 'ADD_ORDER_SUCCESS';
export const ADD_ORDER_ERROR = 'ADD_ORDER_ERROR';


export const STRIPE_PUBLISHABLE_KEY_START = 'STRIPE_PUBLISHABLE_KEY_START';
export const STRIPE_PUBLISHABLE_KEY_SUCCESS = 'STRIPE_PUBLISHABLE_KEY_SUCCESS';
export const STRIPE_PUBLISHABLE_KEY_ERROR = 'STRIPE_PUBLISHABLE_KEY_ERROR';

export const ADD_CARD_DETAILS_START = 'ADD_CARD_DETAILS_START';
export const ADD_CARD_DETAILS_SUCCESS = 'ADD_CARD_DETAILS_SUCCESS';
export const ADD_CARD_DETAILS_ERROR = 'ADD_CARD_DETAILS_ERROR';


export const CONFIRM_SETUP_INTENT_START = 'CONFIRM_SETUP_INTENT_START';
export const CONFIRM_SETUP_INTENT_SUCCESS = 'CONFIRM_SETUP_INTENT_SUCCESS';
export const CONFIRM_SETUP_INTENT_ERROR = 'CONFIRM_SETUP_INTENT_ERROR';

export const REMOVE_CARD_DETAILS_START = 'REMOVE_CARD_DETAILS_START';
export const REMOVE_CARD_DETAILS_SUCCESS = 'REMOVE_CARD_DETAILS_SUCCESS';
export const REMOVE_CARD_DETAILS_ERROR = 'REMOVE_CARD_DETAILS_ERROR';

export const ADD_WALLET_DETAILS_START = 'ADD_WALLET_DETAILS_START';
export const ADD_WALLET_DETAILS_SUCCESS = 'ADD_WALLET_DETAILS_SUCCESS';
export const ADD_WALLET_DETAILS_ERROR = 'ADD_WALLET_DETAILS_ERROR';

export const CONFIRM_PAYMENT_INTENT_START = 'CONFIRM_PAYMENT_INTENT_START';
export const CONFIRM_PAYMENT_INTENT_SUCCESS = 'CONFIRM_PAYMENT_INTENT_SUCCESS';
export const CONFIRM_PAYMENT_INTENT_ERROR = 'CONFIRM_PAYMENT_INTENT_ERROR';

export const SET_PAYOUT_CURRENCY_START = 'SET_PAYOUT_CURRENCY_START';
export const SET_PAYOUT_CURRENCY_SUCCESS = 'SET_PAYOUT_CURRENCY_SUCCESS';
export const SET_PAYOUT_CURRENCY_ERROR = 'SET_PAYOUT_CURRENCY_ERROR';


export const CLEAR_ORDER_ITEM_START = 'CLEAR_ORDER_ITEM_START';
export const CLEAR_ORDER_ITEM_SUCCESS = 'CLEAR_ORDER_ITEM_SUCCESS';
export const CLEAR_ORDER_ITEM_ERROR = 'CLEAR_ORDER_ITEM_ERROR';


export const REMOVE_ORDER_ITEM_START = 'REMOVE_ORDER_ITEM_START';
export const REMOVE_ORDER_ITEM_SUCCESS = 'REMOVE_ORDER_ITEM_SUCCESS';
export const REMOVE_ORDER_ITEM_ERROR = 'REMOVE_ORDER_ITEM_ERROR';

export const REVIEW_IMAGE_UPLOAD_START = 'REVIEW_IMAGE_UPLOAD_START';
export const REVIEW_IMAGE_UPLOAD_SUCCESS = 'REVIEW_IMAGE_UPLOAD_SUCCESS';
export const REVIEW_IMAGE_UPLOAD_ERROR = 'REVIEW_IMAGE_UPLOAD_ERROR'

export const REMOVE_REVIEW_IMAGE_START = 'REMOVE_REVIEW_IMAGE_START';
export const REMOVE_REVIEW_IMAGE_SUCCESS = 'REMOVE_REVIEW_IMAGE_SUCCESS';
export const REMOVE_REVIEW_IMAGE_ERROR = 'REMOVE_REVIEW_IMAGE_ERROR';

export const GET_ORDER_START = 'GET_ORDER_START';
export const GET_ORDER_SUCCESS = 'GET_ORDER_SUCCESS';
export const GET_ORDER_ERROR = 'GET_ORDER_ERROR';

export const CREATE_BOOKING_START = 'CREATE_BOOKING_START';
export const CREATE_BOOKING_SUCCESS = 'CREATE_BOOKING_SUCCESS';
export const CREATE_BOOKING_ERROR = 'CREATE_BOOKING_ERROR';


export const CHANGE_BOOKING_ERROR_SUCCESS = 'CHANGE_BOOKING_ERROR_SUCCESS';
export const CHANGE_BOOKING_ERROR = 'CHANGE_BOOKING_ERROR';

export const CANCEL_BOOKING_START = 'CANCEL_BOOKING_START';
export const CANCEL_BOOKING_SUCCESS = 'CANCEL_BOOKING_SUCCESS';
export const CANCEL_BOOKING_ERROR = 'CANCEL_BOOKING_ERROR';

export const GET_BOOKING_DATA_START = 'GET_BOOKING_DATA_START';
export const GET_BOOKING_DATA_SUCCESS = 'GET_BOOKING_DATA_SUCCESS';
export const GET_BOOKING_DATA_ERROR = 'GET_BOOKING_DATA_ERROR';

export const OPEN_BASE_FARE_MODAL = 'OPEN_BASE_FARE_MODAL';
export const CLOSE_BASE_FARE_MODAL = 'CLOSE_BASE_FARE_MODAL';

export const TOGGLE_ADMIN_MENU = 'TOGGLE_ADMIN_MENU';

export const GET_MAP_DIRECTIONS_START = 'GET_MAP_DIRECTIONS_START';
export const GET_MAP_DIRECTIONS_SUCCESS = 'GET_MAP_DIRECTIONS_SUCCESS';
export const GET_MAP_DIRECTIONS_ERROR = 'GET_MAP_DIRECTIONS_ERROR';

// color code start
export const STAR_FILL_COLOR = '#ff9031';
export const STAR_EMPTY_COLOR = '#767676';
export const LIGHT_MODE_PRIMARY_FOREGROUND = '#181817';
export const DARK_MODE_PRIMARY_FOREGROUND = '#C7D8EB';
export const LIGHT_MODE_PRIMARY_PLACEHOLDER = '#969696';
export const DARK_MODE_PRIMARY_PLACEHOLDER = '#f6f6f699';

//color code end

export const ADD_TIPS_AMOUNT_START = 'ADD_TIPS_AMOUNT_START';
export const ADD_TIPS_AMOUNT_SUCCESS = 'ADD_TIPS_AMOUNT_SUCCESS';
export const ADD_TIPS_AMOUNT_ERROR = 'ADD_TIPS_AMOUNT_ERROR';

export const CHANGE_PAYMENT_TYPE_START = 'CHANGE_PAYMENT_TYPE_START';
export const CHANGE_PAYMENT_TYPE_SUCCESS = 'CHANGE_PAYMENT_TYPE_SUCCESS';
export const CHANGE_PAYMENT_TYPE_ERROR = 'CHANGE_PAYMENT_TYPE_ERROR';

export const MAKE_PAYMENT_START = 'MAKE_PAYMENT_START';
export const MAKE_PAYMENT_SUCCESS = 'MAKE_PAYMENT_SUCCESS';
export const MAKE_PAYMENT_ERROR = 'MAKE_PAYMENT_ERROR';

export const CONFIRM_PAYMENT_START = 'CONFIRM_PAYMENT_START';
export const CONFIRM_PAYMENT_SUCCESS = 'CONFIRM_PAYMENT_SUCCESS';
export const CONFIRM_PAYMENT_ERROR = 'CONFIRM_PAYMENT_ERROR';

export const WRITE_REVIEWS_START = 'WRITE_REVIEWS_START';
export const WRITE_REVIEWS_SUCCESS = 'WRITE_REVIEWS_SUCCESS';
export const WRITE_REVIEWS_ERROR = 'WRITE_REVIEWS_ERROR';

export const UPDATE_REVIEW_STATUS_START = 'UPDATE_REVIEW_STATUS_START';
export const UPDATE_REVIEW_STATUS_SUCCESS = 'UPDATE_REVIEW_STATUS_SUCCESS';
export const UPDATE_REVIEW_STATUS_ERROR = 'UPDATE_REVIEW_STATUS_ERROR';

export const CREATE_SCHEDULE_BOOKING_START = 'CREATE_SCHEDULE_BOOKING_START';
export const CREATE_SCHEDULE_BOOKING_SUCCESS = 'CREATE_SCHEDULE_BOOKING_SUCCESS';
export const CREATE_SCHEDULE_BOOKING_ERROR = 'CREATE_SCHEDULE_BOOKING_ERROR';

export const CANCEL_SCHEDULE_BOOKING_START = 'CANCEL_SCHEDULE_BOOKING_START';
export const CANCEL_SCHEDULE_BOOKING_SUCCESS = 'CANCEL_SCHEDULE_BOOKING_SUCCESS';
export const CANCEL_SCHEDULE_BOOKING_ERROR = 'CANCEL_SCHEDULE_BOOKING_ERROR';

export const ADDITIONAL_FEE_USER_RESPONSE_START = 'ADDITIONAL_FEE_USER_RESPONSE_START';
export const ADDITIONAL_FEE_USER_RESPONSE_SUCCESS = 'ADDITIONAL_FEE_USER_RESPONSE_SUCCESS';
export const ADDITIONAL_FEE_USER_RESPONSE_ERROR = 'ADDITIONAL_FEE_USER_RESPONSE_ERROR';

export const SEND_MESSAGE_START = 'SEND_MESSAGE_START';
export const SEND_MESSAGE_SUCCESS = 'SEND_MESSAGE_SUCCESS';
export const SEND_MESSAGE_ERROR = 'SEND_MESSAGE_ERROR';

export const READ_MESSAGE_START = 'READ_MESSAGE_START';
export const READ_MESSAGE_SUCCESS = 'READ_MESSAGE_SUCCESS';
export const READ_MESSAGE_ERROR = 'READ_MESSAGE_ERROR';

export const SET_PAYPAL_CURRENCY_START = 'SET_PAYPAL_CURRENCY_START';
export const SET_PAYPAL_CURRENCY_SUCCESS = 'SET_PAYPAL_CURRENCY_SUCCESS';
export const SET_PAYPAL_CURRENCY_ERROR = 'SET_PAYPAL_CURRENCY_ERROR';

// Loader Buttons
export const SET_CATEGORY_LOADER_START = 'SET_CATEGORY_LOADER_START';
export const SET_CATEGORY_LOADER_COMPLETE = 'SET_CATEGORY_LOADER_COMPLETE';

export const UPDATE_ONBOARDING_CONTENT_START = 'UPDATE_ONBOARDING_CONTENT_START';
export const UPDATE_ONBOARDING_CONTENT_SUCCESS = 'UPDATE_ONBOARDING_CONTENT_SUCCESS';
export const UPDATE_ONBOARDING_CONTENT_ERROR = 'UPDATE_ONBOARDING_CONTENT_ERROR';

export const OPEN_PROVIDER_APPROVAL_MODAL = 'OPEN_PROVIDER_APPROVAL_MODAL';
export const CLOSE_PROVIDER_APPROVAL_MODAL = 'CLOSE_PROVIDER_APPROVAL_MODAL';